import { render, staticRenderFns } from "./CertificacoesSelos.vue?vue&type=template&id=31d99f9e&scoped=true"
import script from "./CertificacoesSelos.vue?vue&type=script&lang=js"
export * from "./CertificacoesSelos.vue?vue&type=script&lang=js"
import style0 from "./CertificacoesSelos.vue?vue&type=style&index=0&id=31d99f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d99f9e",
  null
  
)

export default component.exports